import { PlaceholderValue, StaticImport } from 'next/dist/shared/lib/get-img-props';
import Image from 'next/image';
import { CSSProperties } from 'react';

interface Props {
  src: string | StaticImport;
  alt: string;
  blur?: string | undefined;
  dimension?: {
    sizes?: string;
    width?: number;
    height?: number;
  };
  relative?: boolean;
  styles?: string;
  extraStyles?: CSSProperties;
  priority?: boolean;
  objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
  objectPosition?: string;
  credit?: string;
}

export default function DirectusImage({
  alt,
  src,
  dimension,
  styles,
  blur,
  priority = false,
  objectFit = 'cover',
  objectPosition = '',
  extraStyles,
  relative = false,
  credit = '',
}: Props) {
  const blurOptions = blur ? { placeholder: 'blur' as PlaceholderValue, blurDataURL: blur } : {};
  const { sizes, width = 1000, height = 1000 } = dimension || {};
  const sizesAttributes = sizes ? { sizes } : {};
  const widthHeightAttributes = sizes ? {} : { width, height };
  const fillAttributes = sizes && !relative ? { fill: true } : false;
  const widthAttributes = relative ? { width: width } : false;
  const heightAttributes = relative ? { height: height } : false;
  const overrideSrcIsStatic = typeof src === 'object';
  const overrideSrcAttributes = !overrideSrcIsStatic ? { overrideSrc: src as string } : {};
  if (!src) {
    return <></>;
  }

  return (
    <span style={extraStyles}>
      <Image
        alt={alt}
        src={src}
        quality={90}
        className={styles}
        style={{
          objectFit,
          objectPosition,
          ...extraStyles,
        }}
        {...widthAttributes}
        {...heightAttributes}
        {...overrideSrcAttributes}
        // style={{ ...styles, ...extraStyles }}
        {...fillAttributes}
        {...sizesAttributes}
        {...widthHeightAttributes}
        {...blurOptions}
        priority={priority}
      />
      {credit && (
        <div className="absolute bottom-2 right-2 z-2 flex max-w-max rounded bg-white/30 px-2 py-1 backdrop-blur-sm">
          <span className="text-xs text-white">
            {credit.includes('©') ? credit : `© ${credit}`}
          </span>
        </div>
      )}
    </span>
  );
}
